<template>
  <div class="page">
    <div class="page_header">로그인</div>
    <div class="page_header_line"></div>
    <div class="description">
      고객님께서 해당하는 회원의 종류를 선택해주세요.<br />
      회원가입 후 최종 승인완료가 되면 정상적인 서비스 이용이 가능합니다.<br />
      통합회원과 일반회원을 반드시 구분하여 가입하시기 바라며 로그인 시 자동으로 권한에 따라 컨텐츠가 구분됩니다.
    </div>
    <div class="login_wrap">
      <div><img src="@/assets/images/certification_icon.png" /></div>
      <div class="login_btn" @click="login = true" style="position: relative;">사용자 범용 인증서
        <div v-if="capsLockOn" class="caps-lock-warning">
          Caps Lock이 켜져있습니다
        </div>
      </div>
      <div class="join_btn" @click="goPage('signup')">회원가입</div>
      <input 
        ref="hiddenInput" 
        type="text" 
        style="position: absolute; opacity: 0; pointer-events: none;" 
        @keydown="handleKeyDown"
        @input="checkCapsLock"
      />
    </div>
  </div>
  <authModal v-if="login" @close="close" :businessno="''"/>
</template>

<script setup lang="ts">
import { useRouter } from "vue-router";
import { userStore } from "@/store/userStore";
import authModal from "@/components/popup/authModal.vue";
import { onMounted, onUnmounted, ref } from "vue";
const store = userStore();
const router = useRouter();
const login = ref(false);
const close = () => {
  login.value = false;
}
let interval
const hiddenInput = ref<HTMLInputElement>();
const capsLockOn = ref(false);
const checkCapsLock = (event?: KeyboardEvent) => {
  // event가 없으면 현재 상태를 유지
  if (!event) return;
  
  if (event.getModifierState && event.getModifierState("CapsLock")) {
    capsLockOn.value = true;
    clearInterval(interval); // 초기 확인 후 인터벌 정리
  } else {
    capsLockOn.value = false;
  }
};
const handlePageClick = () => {
  // 숨겨진 입력 필드에 포커스하여 Caps Lock 상태 확인
  if (hiddenInput.value) {
    hiddenInput.value.focus();
    
    // 포커스가 사용자에게 보이지 않도록 즉시 blur 처리
    setTimeout(() => {
      hiddenInput.value?.blur();
    }, 0);
  }
};
const handleKeyDown = (event: KeyboardEvent) => {
  checkCapsLock(event);
};

const goPage = (page: string) => {
  window.scrollTo({ top: 0, behavior: "auto" });
  router.push({ name: page });
};
onUnmounted(() => {
  login.value = false;
});
onMounted(() => {
  // 키보드 이벤트 리스너
  window.addEventListener("keydown", handleKeyDown);
  
  // 페이지 클릭 이벤트 리스너
  document.addEventListener("click", handlePageClick);
  
  // 페이지 로드 시 초기 확인 시도
  // 브라우저는 페이지 로드 시 Caps Lock 상태를 바로 알려주지 않으므로 
  // 사용자가 숨겨진 입력 필드에 포커스할 수 있도록 함
});
</script>

<style scoped>
.caps-lock-warning {
  background: #f63131;
  color: #fff;
  font-size: 12px;
  margin-top: 5px;
  position: absolute;
  top: -50%;
  right: -110px;
  border-radius: 10px;
  padding: 10px;
  font-weight: 900;
}
.page {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 100px;
}

.page_title {
  display: flex;
  flex-direction: row;
  width: 80%;
  align-items: center;
  font-family: "Noto Sans CJK KR-Bold";
  padding: 30px 0px;
}

.login_wrap {
  border: 0.1px solid #d0d0d0;
  width: 80%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  height: 453px;
  border-radius: 15px;
  box-shadow: 4px 4px 8px 0px #0000000d;
}

.login_btn {
  width: 341px;
  height: 60px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 16px;
  font-family: "Noto Sans CJK KR-Medium";
  background: #3382e9;
  color: white;

  border-radius: 8px;
}

.join_btn {
  width: 341px;
  height: 60px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 16px;
  font-family: "Noto Sans CJK KR-Medium";
  background: #232a58;
  color: white;
  border-radius: 8px;
}

.page_header_line {
  width: 36px;
  border-bottom: 3px solid #000000;
  margin-bottom: 20px;
}

.page_header {
  padding: 80px 30px 15px 30px;
  font-family: "Noto Sans CJK KR-Bold";
  font-size: 24px;
  /* text-align: center; */
}

.description {
  text-align: center;
  font-size: 14px;
  font-family: "Noto Sans CJK KR-Light";
  color: #6d6d6d;
  margin-bottom: 40px;
}
</style>
